<template>
    <div>
        <div class="max-w-6xl mx-auto intro-y grid grid-cols-12 gap-6 mt-5">
            <!-- BEGIN: Blog Layout -->
            <div @click="edit(myNew)" v-for="(myNew, indexNew) in filteredNews" :key="indexNew" class="intro-y col-span-12 md:col-span-6 xl:col-span-4 box" :class="{'bg-theme-1 text-white':indexNew == 0}">
                <div class="p-5">
                    <div class="h-40 xxl:h-56 image-fit">
                        <img :alt="myNew.title" v-if="myNew.image && myNew.image[0]" class="rounded-md" :src="myNew.image[0].urlPath" />
                        <div class="w-full h-full bg-gray-200 flex justify-center items-center" v-if="!myNew.image || !myNew.image[0]">
                            <div class="text-gray-700">Sin imágen</div>
                        </div>
                    </div>
                    <span class="block font-medium text-base mt-5">{{myNew.title}}</span>
                    <div class="mt-2 whitespace-pre-line" :class="{'text-white dark:text-white ':indexNew == 0,'text-gray-700 dark:text-gray-600 ':indexNew != 0}">
                        {{ myNew.text }}
                    </div>
                </div>
            </div>
            <!-- END: Blog Layout -->
        </div>
        <modal :data="{ 'id':'ok-confirmation-modal', 'title':'Guardado', 'text':'La noticia ha sido guardada', 'icon':'check'}"></modal>
        <modal :data="{ 'id':'error-confirmation-modal', 'title':'Error', 'text':'Ha ocurrido un error al guardar', 'icon':'x'}"></modal>
        <div v-if="newTablon" class="z-70 fixed fixed top-0 left-0 w-full h-full flex items-center justify-center p-12">
            <div @click="newTablon = null; allowNewImage = false" class="absolute top-0 left-0 w-full h-full bg-blue-400 z-70 opacity-50"></div>
            <div class="bg-white relative z-70 shadow-lg rounded-lg w-full max-w-6xl max-h-full overflow-auto">
                <div class="p-8">
                    <div v-if="(!newImage && (!newTablon.image || !newTablon.image[0])) || allowNewImage">
                        <vue-dropzone class="bg-gray-200 p-8 rounded-lg shadow-none border-2 border-dashed flex items-center justify-center" ref="myVueDropzone" id="dropzone" v-on:vdropzone-success="saveImage" :options="dropzoneOptions"></vue-dropzone>
                    </div>
                    <div v-if="!newImage && newTablon.image && newTablon.image[0] && !allowNewImage">
                        <div class="bg-gray-200 p-8 rounded-lg shadow-none border-2 border-dashed flex items-center justify-center flex-col">
                            <img class="max-w-sm w-full h-64 object-cover" :src="newTablon.image[0].urlPath">
                        </div>
                    </div>
                    <div v-if="newImage && !allowNewImage">
                        <div class="bg-gray-200 p-8 rounded-lg shadow-none border-2 border-dashed flex items-center justify-center flex-col">
                            <img class="max-w-sm w-full h-64 object-cover" :src="newImage">
                        </div>
                    </div>
                    <div v-if="(newImage || (newTablon.image && newTablon.image[0])) && !allowNewImage">
                        <button @click="newImage = null; allowNewImage = true" class="mx-auto mt-4 dropdown-toggle cursor-pointer button text-white bg-theme-1 shadow-md flex items-center">Subir otra foto</button>
                    </div>
                    <div>
                        <input v-model="newTablon.title" type="text" class="input w-full bg-gray-200 border mt-2" placeholder="Título del anuncio" />
                    </div>
                    <div>
                        <textarea v-model="newTablon.text" class="input h-64 w-full bg-gray-200 border mt-2" placeholder="Contenido del anuncio"></textarea>
                    </div>
                    <div class="flex justify-end ml-auto">
                        <button v-if="newTablon.num && isAdmin" @click="remove" class="mx-2 my-4 dropdown-toggle cursor-pointer button text-white bg-theme-6 shadow-md flex items-center">
                            <TrashIcon class="mr-2" />
                            Eliminar
                        </button>
                        <button :disabled="!newTablon.title || !newTablon.text" @click="save" class="mx-2 my-4 dropdown-toggle cursor-pointer button text-white bg-theme-1 shadow-md flex items-center">
                            <PlusIcon class="mr-2" />
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.z-70 {
    z-index: 70
}
</style>
<script>
import Vue from "vue";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Modal from "@/global-components/Modal";

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Modal
    },
    data() {
        return {
            searchTerm: "",
            data: [],
            newTablon: null,
            newImage: null,
            allowNewImage: false,
            dropzoneOptions: {
                url: '/file-upload/',
                thumbnailWidth: 150,
                maxFilesize: 3,
                acceptedFiles: 'image/*',
                headers: { "My-Awesome-Header": "header value" },
                dictDefaultMessage: `
                    <div class="flex justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 w-20 h-20 text-gray-300 feather feather-file"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
                        <p class="text-gray-600">Arrastra o haz clic para subir el documento seleccionado</p>
                    </div>
                `,
                dictFallbackMessage: "Tu navegador no soporta la subida de archivos mediante arrastrar y soltar.",
                dictFallbackText: "Por favor, usa el siguiente formulario para subir tus archivos como en los viejos tiempos.",
                dictFileTooBig: "El archivo es demasiado grande ({{filesize}}MiB). Tamaño máximo de archivo: {{maxFilesize}}MiB.",
                dictInvalidFileType: "No puedes subir archivos de este tipo.",
                dictResponseError: "El servidor respondió con el código {{statusCode}}.",
                dictCancelUpload: "Cancelar la carga",
                dictCancelUploadConfirmation: "¿Estás seguro de que quieres cancelar esta subida?",
                dictRemoveFile: "Eliminar el archivo",
                dictMaxFilesExceeded: "No puedes subir más archivos.",
            },
        }
    },
    computed: {
        isAdmin() {
            return window.bus.admin;
        },
        filteredNews() {
            if (!this.searchTerm) return this.data;
            return this.data.filter(rec => rec.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1)
        }
    },
    mounted() {
        window.bus.$on('dataReloaded', () => {
            this.loadData();
        })
        this.loadData();
        window.bus.$on("tablon-search", (data) => {
            this.searchTerm = data.searchTerm;
        });
        window.bus.$on("tablon-create", (data) => {
            this.allowNewImage = true;
            this.newTablon = {
                num: null,
                title: '',
                text: '',
                image: null
            };
        });
    },
    methods: {
        loadData() {
            CmsApi.hook("/hooks/getTablon/", { searchterm: this.searchTerm, token: this.$cookie.get("token") }, (data) => {
                if (data.success && data.data) this.data = data.data;
            });
        },
        closeModal() {
            this.newTablon = null;
            this.newImage = null;
            this.allowNewImage = false;
            cash("#ok-confirmation-modal").modal("show");
        },
        edit(tablon) {
            if(!window.bus.admin) return;
            this.newImage = null;
            this.newTablon = tablon;
        },
        saveImage(file, response) {
            this.$refs.myVueDropzone.removeFile(file);
            try {
                response = JSON.parse(response);
                if (response.data && response.data[0]) {
                    this.newImage = response.data[0].urlPath;
                    this.allowNewImage = false;
                    console.log(this.newImage)
                }
            } catch (error) {
                console.error({ 'response': response, 'error': error });
            }
        },
        async save() {
            let data = this.newTablon;
            data.newImage = this.newImage;
            let response = await CmsApi.hook('/hooks/save/', {'action': 'guardar_tablon', 'data': JSON.stringify(data)});
            this.closeModal();
            if(response.success) {
                window.bus.$emit("reloadDataFromServer", {});
            } else {
                alert('Ha habido un error al guardar la noticia, si este error persiste contacte con el administrador y facilítele el archivo que trata de subir');
            }
        },
        async remove() {
            if(this.newTablon.num && confirm('Se eliminará permanentemente. ¿Está seguro?')) {
                let data = {num: this.newTablon.num};
                let response = await CmsApi.hook('/hooks/save/', {'action': 'borrar_tablon', 'data': JSON.stringify(data)});
                this.closeModal();
                if(response.success) {
                    window.bus.$emit("reloadDataFromServer", {});
                } else {
                    alert('Ha habido un error al eliminar la noticia, si este error persiste contacte con el administrador y facilítele el archivo que trata de subir');
                }
            }
        }
    }
}
</script>